/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo, useCallback, useEffect, forwardRef } from 'react';
import ReactScrollWheelHandler from 'react-scroll-wheel-handler';

import usePageNavigation from '../navigation/usePageNavigation';

const CustomComponent = forwardRef(({ children, ...props }, ref) => {
	const { setScrollingNode } = usePageNavigation();
	useEffect(() => {
		setScrollingNode(ref.current);
	}, [ref, setScrollingNode]);
	return (
		<div ref={ref} {...props} id="custom">
			{children}
		</div>
	);
});

const MainScroll = ({ as: Component = 'div', ...props }) => {
	const { scrollToNext, scrollToPrev } = usePageNavigation();

	const goNext = useCallback(() => {
		scrollToNext();
	}, [scrollToNext]);
	const goPrev = useCallback(() => {
		scrollToPrev();
	}, [scrollToPrev]);

	return (
		<ReactScrollWheelHandler
			CustomComponent={CustomComponent}
			timeout={600}
			upHandler={goPrev}
			downHandler={goNext}
			css={css`
				height: 100%;
				overflow: hidden;
			`}
			{...props}
		/>
	);
};

export default memo(MainScroll);
